// extracted by mini-css-extract-plugin
export default {"regularExpressions":"RegularExpressions_regularExpressions__UR-yv"};